import na from './na.js'
import emea from './emea.js'

export default {na, emea}

